import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import PlatformAuth, { isPlatformPath } from './platform/PlatformAuth';

// The old standalone sign-in page now lives in the console itself.
if (window.location.pathname.replace(/\/+$/, '') === '/signin') {
  window.history.replaceState(null, '', '/');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {isPlatformPath(window.location.pathname) ? <PlatformAuth /> : <App />}
    </ErrorBoundary>
  </React.StrictMode>
);
